<app-section #parentSection
             [title]="title"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig"
             [containerClass]="false">

    <ng-template #section>
        <div class="color-054 font-14 padding-top">
            Zapoznaj się z:
            <a href="{{distributorInfo}}" class="bold" target="_blank">
                Informacjami dotyczącymi dystrybutora ubezpieczeń
            </a>
            oraz
            <a href="{{administrationPersonalData}}" class="bold" target="_blank">
                Informacją o administratorze danych osobowych.
            </a>
        </div>
    </ng-template>
</app-section>
